<template>
  <div class="container">
    <!-- <BaseLoader
      v-if="cargando"
    /> -->
    <!-- <table v-else> -->
    <div class="form_section">
      <label for="alumno_id" class="label_crear_mentor">Nombre del mentoreado</label>
      <v-select
        class="contenedor_select_buscador"
        label="item_data"
        :reduce="mentoreados => mentoreados.persona_id"
        :options="mentoreados"
        :disabled="cargando"
        v-model.number="selected.mentoreado_id"
        @input="traerMentoriasPorFiltro()"
      >
        <span slot="no-options" @click="$refs.select.open = false" class="select_buscador_warning">
          <p>La persona ingresada no está cursando la mentoría.</p>
        </span>
      </v-select>
    </div>
    <div class="form_section">
      <label for="alumno_id" class="label_crear_mentor">Nombre del mentor</label>
      <v-select
        class="contenedor_select_buscador"
        label="item_data"
        :reduce="mentores => mentores.persona_id"
        :options="mentores"
        :disabled="cargando"
        v-model.number="selected.mentor_id"
        @input="traerMentoriasPorFiltro()"
      >
        <span slot="no-options" @click="$refs.select.open = false" class="select_buscador_warning">
          <p>La persona ingresada no está cursando la mentoría.</p>
        </span>
      </v-select>
    </div>
    <div class="contenedor_filtro">
      <div class="contenedor_filto_item">
        <h3>Condición</h3>
        <div
          v-for="condicion in condiciones"
          :key="'condiciones_mentoria_'+condicion.condiciones_mentoria_id"
        >
          <input
            type="checkbox"
            :value="condicion.condiciones_mentoria_id"
            :id="'condiciones_mentoria_'+condicion.condiciones_mentoria_id"
            v-model="selected.condiciones_mentoria_id"
            @change="traerMentoriasPorFiltro()"
          >
          <label :for="'condiciones_mentoria_'+condicion.condiciones_mentoria_id">{{ condicion.nombre }}</label>
        </div>
      </div>
      <div class="contenedor_filto_item">
          <h3>Mentoría</h3>
          <div          >
            <input
              type="checkbox"
              :value=0
              id="mentoria_1"
              v-model="selected.fecha_finalizacion"
              @change="traerMentoriasPorFiltro()"
            >
            <label for="mentoria_1">Abierta</label>
          </div>
          <div          >
            <input
              type="checkbox"
              :value=1
              id="mentoria_2"
              v-model="selected.fecha_finalizacion"
              @change="traerMentoriasPorFiltro()"
            >
            <label for="mentoria_2">Cerrada</label>
          </div>
      </div>
    </div>
    <table id="tabla-servicios">
      <thead>
        <th>Mentoreado</th>
        <th>Mentor</th>
        <th>Fecha Inicio</th>
        <th>Fecha Finalización</th>
        <th>Condición</th>
        <th>Comentario Mentor</th>
        <th>Comentario CMC</th>
      </thead>
      <tbody>
        <MentoriasListaItem
          v-for="mentoria in mentorias"
          :mentoria="mentoria"
          :key="mentoria.mentoria_id"
          @refrescar="refrescar"
        ></MentoriasListaItem>
      </tbody>
    </table>
  </div>
</template>

<script>
import 'vue-select/dist/vue-select.css'
import MentoriasListaItem from '../components/MentoriasListaItem.vue'
// import Header2 from '../components/Header2.vue'
import mentorService from '../services/mentor'
// import personasService from '../services/personas'
export default {
  name: 'MentoriasLista',
  components: {
    MentoriasListaItem
    // Header2
  },
  data: function () {
    return {
      cargando: false,
      mentorias: [],
      mentores: [],
      mentoreados: [],
      condiciones: [],
      selected: {
        condiciones_mentoria_id: [],
        fecha_finalizacion: [],
        mentoreado_id: null,
        mentor_id: null
      }
    }
  },
  methods: {
    selectUpdateHandler (value) {
      console.log('selectUpdateHandler', value)
    },
    traerMentoriasPorFiltro () {
      // if (event.target.value != null) {
      //   console.log('ewer66666666666werewrew')
      // }
      console.log('ewerwerewrew')
      console.log(this.selected)
      // this.busqueda = null
      // this.cargando = true
      mentorService
        .traerMentoriasPorFiltro(JSON.stringify(this.selected))
        .then(respuesta => {
          // this.cargando = false
          // this.currentPage = 1
          // this.socios = []
          // this.socios = respuesta
          console.log('INFO POR FILTRO', respuesta)
          this.mentorias = respuesta
          // this.pageCount = Math.ceil(this.socios.length / this.sizePaginado)
          // this.exportarExcel(respuesta)
        })
    },
    refrescar () {
      mentorService
        .traerMentoriasTodas()
        .then(respuesta => {
          // this.cargando = false
          this.mentorias = respuesta
          console.log('Todas las Mentorías', respuesta)
        })
    }
  },
  mounted: function () {
    // this.cargando = true
    mentorService
      .traerMentoriasTodas()
      .then(respuesta => {
        // this.cargando = false
        this.mentorias = respuesta
        console.log('Todas las Mentorías', respuesta)
      })
    mentorService
      .traerCondicionesMentoriaTodos()
      .then(respuesta => {
        // this.cargando = false
        this.condiciones = respuesta
      })
    mentorService
      .traerMentoresConMentoriasTodos()
      .then(respuesta => {
        // this.cargando = false
        console.log('qqqqq', respuesta.data)
        this.mentores = respuesta.data.mentores
        this.mentores.map(function (x) {
          // const pepe = x.nombre + ' ' + x.apellido
          // console.log(pepe)
          x.item_data = x.nombre + ' ' + x.apellido
          // return x.item_data = pepe
        })
        this.mentoreados = respuesta.data.mentoreados
        this.mentoreados.map(function (x) {
          // const pepe = x.nombre + ' ' + x.apellido
          // console.log(pepe)
          x.item_data = x.nombre + ' ' + x.apellido
          // return x.item_data = pepe
        })
        console.log('mentores', this.mentores)
        console.log('mentoreados', this.mentoreados)
      })
  }
}
</script>
